/**
 * AR content for the "Cannes – Gourdon" private excursion.
 *
 * Role: Arabic (MSA) translation of slugs/cannes-gourdon.ts, typed
 * `ExcursionPage` for the shared ExcursionSlugView.
 * Dependencies: slug-excursions (type), image. Slug mirrors FR (place names).
 */
import type { ExcursionPage } from "../slug-excursions";
import gourdon from "@/assets/images/excursions/destinations/cannes.webp";

const page: ExcursionPage = {
  slug: "cannes-gourdon",
  hero: {
    title: "رحلة كان – غوردون",
    subtitle: "من شواطئ كان إلى قرية غوردون المعلّقة، تباين مذهل.",
    ctaPrimaryHref: "/reservation",
    ctaPrimaryLabel: "احجز الآن",
    ctaSecondaryHref: "/contact",
    ctaSecondaryLabel: "اطلب عرض سعر",
    image: gourdon,
  },
  highlights: {
    title: "أبرز المعالم",
    items: [
      { text: "كان: الكروازيت والسوكيه والشواطئ الخاصة (إطلالة)" },
      { text: "غوردون: قرية معلّقة بإطلالة بانورامية استثنائية" },
      { text: "حرفيون وحلويات وعطور ومنتجات محلية" },
      { text: "طريق خلّاب عبر المناطق الداخلية للريفييرا" },
    ],
  },
  itinerary: {
    title: "برنامج مقترح",
    steps: [
      {
        title: "كان",
        description: "الانطلاق وجولة سريعة حسب رغبتك.",
      },
      {
        title: "الطريق نحو المناطق الداخلية",
        description: "نقاط مشاهدة ووقفات للتصوير.",
      },
      {
        title: "غوردون",
        description: "اكتشاف القرية ووقت حر.",
      },
    ],
  },
  practical: {
    title: "معلومات عملية",
    items: [
      { label: "المدة", value: "من 4 إلى 6 ساعات" },
      { label: "الانطلاق", value: "كان" },
      { label: "نصيحة", value: "أحذية مريحة (أزقّة مرصوفة بالحجارة)" },
      { label: "خيار", value: "وقفة عند العطّار / الحلويات حسب الرغبة" },
    ],
  },
};

export default page;
